<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="evento" titulo="Evento / Eventos" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <a id="catalogos" (click)="ctrl.cargarCatalogo('categorias_eventos', 'categoria-evento');"></a>"
            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">
                  <div class="tabs is-boxed">
                    <ul>
                      <li [ngClass]="{ 'is-active' : tab == 1}">
                        <a (click)="tab=1">
                          <span class="icon ">
                            <i class="icon-agenda-2 "></i>
                          </span>
                          <span>General</span>
                        </a>
                      </li>

                      <li [ngClass]="{ 'is-active' : tab == 2}">
                        <a (click)="tab=2">
                          <span class="icon ">
                            <i class="icon-calendar-10 "></i>
                          </span>
                          <span>Fechas</span>
                        </a>
                      </li>

                      <li [ngClass]="{ 'is-active' : tab == 3}">
                        <a (click)="tab=3">
                          <span class="icon ">
                            <i class="icon-list-12"></i>
                          </span>
                          <span>Secciones</span>
                        </a>
                      </li>

                      <li [ngClass]="{ 'is-active' : tab == 4}">
                        <a (click)="tab=4">
                          <span class="icon ">
                            <i class="icon-money-2 "></i>
                          </span>
                          <span>Costos</span>
                        </a>
                      </li>

                      <li [ngClass]="{ 'is-active' : tab == 5}">
                        <a (click)="tab=5">
                          <span class="icon ">
                            <i class="icon-certificate "></i>
                          </span>
                          <span>Constancias</span>
                        </a>
                      </li>
                      <!--
                      <li [ngClass]="{ 'is-active' : tab == 6}">
                        <a (click)="tab=6">
                          <span class="icon ">
                            <i class="icon-polling"></i>
                          </span>
                          <span>Encuestas</span>
                        </a>
                      </li>
                      -->
                    </ul>
                  </div>
                  <div [ngClass]="{ 'is-hidden': tab != 1}">
                    <div>
                      <div class="column is-12">
                        <div class="field">
                          <label class="label">Categoría evento:</label>
                          <div class="control has-icons-left has-icons-right">
                            <ng-select2 [disabled]="ctrl.categorias_eventos ? ctrl.categorias_eventos.length == 0 ? true : false : true" name="categorias_eventos_id" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.categorias_eventos_id.value"
                              (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.categorias_eventos_id);" [data]="ctrl.categorias_eventos"></ng-select2>
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.categorias_eventos_id.hasError('required') ">
                              <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.controls.categorias_eventos_id.hasError('required') ">Este campo es requerido.</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns">
                        <div class="column is-12">
                            <div class="field">
                                <label class="label">Nombre:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }" placeholder="Nombre"
                                        formControlName="nombre">
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                      <div class="column is-12">
                        <div class="field">
                            <label class="label">Imagen:</label>
                            <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.get('imagen').value == ''">
                                <div class="file has-name">
                                    <label class="file-label">
                                        <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.imagen, false, 0)" accept="image/x-png,image/gif,image/jpeg,image/jpg">
                                        <input foto type="hidden" formControlName="imagen">
                                        <span class="file-cta">
                                            <span class="file-icon">
                                                <i class="fa fa-upload"></i>
                                            </span>
                                            <span class="file-label">
                                                Seleccionar archivo
                                            </span>
                                        </span>

                                    </label>
                                </div>
                            </div>
                            <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.imagen, 'categoria')"
                                *ngIf="ctrl.dato.get('imagen').value != ''">

                                <span class="icon ">
                                    <i class="icon-trash"></i>
                                </span>
                                &nbsp; Eliminar la imagen
                            </button>

                            <button type="button" class="button is-success" *ngIf="ctrl.dato.controls.imagen.value != ''" (click)="ctrl.abrirModal('verFoto')">
                                <span class="icon">
                                    <i class="icon-eye2"> </i>
                                </span>
                                &nbsp; Ver Foto
                            </button>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-12">
                        <div class="field">
                          <label class="label">Descripción</label>
                          <ckeditor formControlName="descripcion" debounce="500" [config]="CkeditorConfig"></ckeditor>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div [ngClass]="{ 'is-hidden': tab != 2}">
                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Fecha inicio inscripción:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="date" [ngClass]="{'is-danger': dato.controls.inicio_inscripcion.hasError('required')}"
                              formControlName="inicio_inscripcion">
                            <span class="icon is-small is-right" *ngIf="dato.controls.inicio_inscripcion.hasError('required') ">
                              <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="dato.controls.inicio_inscripcion.hasError('required') ">Este campo es
                              requerido.</span>
                          </div>
                        </div>
                      </div>

                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Fecha fin inscripción:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="date" [ngClass]="{'is-danger': dato.controls.fin_inscripcion.hasError('required')}"
                              formControlName="fin_inscripcion">
                            <span class="icon is-small is-right" *ngIf="dato.controls.fin_inscripcion.hasError('required') ">
                              <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="dato.controls.fin_inscripcion.hasError('required') ">Este campo es
                              requerido.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Fecha inicio evento:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="date" [ngClass]="{'is-danger': dato.controls.fecha_inicio.hasError('required')}"
                              formControlName="fecha_inicio">
                            <span class="icon is-small is-right" *ngIf="dato.controls.fecha_inicio.hasError('required') ">
                              <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="dato.controls.fecha_inicio.hasError('required') ">Este campo es
                              requerido.</span>
                          </div>
                        </div>
                      </div>

                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Fecha fin evento:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="date" [ngClass]="{'is-danger': dato.controls.fecha_termino.hasError('required')}"
                              formControlName="fecha_termino">
                            <span class="icon is-small is-right" *ngIf="dato.controls.fecha_termino.hasError('required') ">
                              <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="dato.controls.fecha_termino.hasError('required') ">Este campo es
                              requerido.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Tipo de codigo:</label>
                          <div class="control has-icons-left has-icons-right">
                            <br>
                            <div class="b-checkbox is-info" >
                              <input type="radio" name="tipo_codigo" id="tipo_codigo_1" [value]="1" [ngClass]="{'is-danger': dato.controls.tipo_codigo.hasError('required')}"
                                formControlName="tipo_codigo">
                              <label for="tipo_codigo_1">
                                Númerico
                              </label>

                              <input type="radio" name="tipo_codigo" id="tipo_codigo_2" [value]="2" [ngClass]="{'is-danger': dato.controls.tipo_codigo.hasError('required')}"
                                formControlName="tipo_codigo">
                              <label for="tipo_codigo_2">
                                Alfanúmerico
                              </label>
                            </div>

                          </div>
                        </div>
                      </div>

                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Longitud del codigo:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="number" min="1" step="1" [ngClass]="{'is-danger': dato.controls.longitud_codigo.hasError('required')}"
                              formControlName="longitud_codigo">
                            <span class="icon is-small is-right" *ngIf="dato.controls.longitud_codigo.hasError('required') ">
                              <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="dato.controls.longitud_codigo.hasError('required') ">Este campo es
                              requerido.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-12">
                        <div class="field">
                          <label class="label">Mensaje para el correo:</label>
                          <ckeditor formControlName="mensaje_email" debounce="500" [config]="CkeditorConfig"></ckeditor>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div [ngClass]="{ 'is-hidden': tab != 3}" formArrayName="eventos_secciones">
                    <div class="card" *ngFor="let item of ctrl.dato.controls.eventos_secciones.controls; let i = index" [formGroupName]="i">
                      <header class="card-header" style="background: gainsboro">
                        <div class="card-header-title" style="font-weight: 200; display: flow-root;">
                          <div style="float:left" >
                            <strong>#{{i + 1}} -> {{item.controls.nombre.value}}</strong>
                          </div>
                          <div style="float:right" >
                            <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.eventos_secciones, i)">
                              <i class="fa fa-trash-o"></i>
                            </button>
                          </div>
                        </div>
                      </header>
                      <div class="card-content">
                        <div class="content">
                          <div class="columns">
                            <div class="column is-6">
                              <div class="field">
                                <label class="label">Nombre:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [ngClass]="{'is-danger': item.controls.nombre.hasError('required')}"
                                    formControlName="nombre">
                                  <span class="icon is-small is-right" *ngIf="item.controls.nombre.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.nombre.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-6">
                              <div class="field">
                                <label class="label">Fecha:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="date" [min]="dato.controls.fecha_inicio" [max]="dato.controls.fecha_termino" [ngClass]="{'is-danger': item.controls.fecha.hasError('required')}"
                                    formControlName="fecha">
                                  <span class="icon is-small is-right" *ngIf="item.controls.fecha.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.fecha.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                          </div>

                          <div class="columns">
                            <div class="column is-6">
                              <div class="field">
                                <label class="label">Hora inicio:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="time" [ngClass]="{'is-danger': item.controls.hora_inicio.hasError('required')}"
                                    formControlName="hora_inicio">
                                  <span class="icon is-small is-right" *ngIf="item.controls.hora_inicio.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.hora_inicio.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-6">
                              <div class="field">
                                <label class="label">Hora termino:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="time" [min]="item.controls.hora_inicio.value" [ngClass]="{'is-danger': item.controls.hora_termino.hasError('required')}"
                                    formControlName="hora_termino">
                                  <span class="icon is-small is-right" *ngIf="item.controls.hora_termino.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.hora_termino.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="button is-primary is-outlined is-fullwidth" style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                      <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.eventos_secciones, form_eventos_secciones)">
                        <i class="fa fa-plus"></i> &nbsp; Agregar
                      </button>
                    </div>

                  </div>

                  <div [ngClass]="{ 'is-hidden': tab != 4}" formArrayName="eventos_costos">
                    <div class="card" *ngFor="let item of ctrl.dato.controls.eventos_costos.controls; let i = index" [formGroupName]="i">
                      <header class="card-header" style="background: gainsboro">
                        <div class="card-header-title" style="font-weight: 200; display: flow-root;">
                          <div style="float:left">
                            <strong>#{{i + 1}} -> {{item.controls.nombre.value}}</strong>
                          </div>
                          <div style="float:right">
                            <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.eventos_costos, i)">
                              <i class="fa fa-trash-o"></i>
                            </button>
                          </div>
                        </div>
                      </header>
                      <div class="card-content">
                        <div class="content">
                          <div class="columns">
                            <div class="column is-6">
                              <div class="field">
                                <label class="label">Nombre:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [ngClass]="{'is-danger': item.controls.nombre.hasError('required')}"
                                    formControlName="nombre">
                                  <span class="icon is-small is-right" *ngIf="item.controls.nombre.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.nombre.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-6">
                              <div class="field">
                                <label class="label">Importe:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="number" min="0" [ngClass]="{'is-danger': item.controls.importe.hasError('required')}" formControlName="importe">
                                  <span class="icon is-small is-right" *ngIf="item.controls.importe.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.importe.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="button is-primary is-outlined is-fullwidth" style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                      <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.eventos_costos, form_eventos_costos)">
                        <i class="fa fa-plus"></i> &nbsp; Agregar
                      </button>
                    </div>
                  </div>

                  <div [ngClass]="{ 'is-hidden': tab != 5}" formArrayName="eventos_constancias">
                  <div class="card" *ngFor="let item of ctrl.dato.controls.eventos_constancias.controls; let i = index" [formGroupName]="i">
                    <header class="card-header" style="background: gainsboro">
                      <div class="card-header-title" style="font-weight: 200; display: flow-root;">
                        <div style="float:left">
                          <strong>#{{i + 1}}</strong>
                        </div>
                        <div style="float:right">
                          <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.eventos_constancias, i)">
                            <i class="fa fa-trash-o"></i>
                          </button>
                        </div>
                      </div>
                    </header>
                    <div class="card-content">
                      <div class="content">
                        <div class="columns">
                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Orientacion:</label>
                              <div class="control has-icons-left has-icons-right">
                                <br>
                                <div class="b-checkbox is-info">
                                  <input type="radio" name="orientacion" id="orientacion_1" [value]="'portrait'" [ngClass]="{'is-danger': item.controls.orientacion.hasError('required')}"
                                    formControlName="orientacion">
                                  <label for="orientacion_1">
                                    Vertical
                                  </label>

                                  <input type="radio" name="orientacion" id="orientacion_2" [value]="'landscape'" [ngClass]="{'is-danger': item.controls.orientacion.hasError('required')}"
                                    formControlName="orientacion">
                                  <label for="orientacion_2">
                                    Horizontal
                                  </label>
                                </div>

                              </div>
                            </div>
                          </div>

                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Tamaño de la hoja:</label>
                              <div class="control has-icons-left has-icons-right">
                                <ng-select2 [disabled]="tamanios_papel ? tamanios_papel.length == 0 ? true : false : true" name="tamanio_papel" [options]="ctrl.optionSelect" [value]="item.controls.tamanio_papel.value" (valueChanged)="ctrl.seleccionarValorSelect2($event, item.controls.tamanio_papel);"
                                  [data]="tamanios_papel"></ng-select2>
                                <span class="icon is-small is-right" *ngIf="item.controls.tamanio_papel.hasError('required') ">
                                  <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="item.controls.tamanio_papel.hasError('required') ">Este campo es requerido.</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Fondo:</label>
                              <div class="control has-icons-left has-icons-right" *ngIf="item.get('background').value == ''">
                                <div class="file has-name">
                                  <label class="file-label">
                                    <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, item.controls.background, false, 'b' + i)"
                                      accept="image/x-png,image/gif,image/jpeg,image/jpg">
                                    <input foto type="hidden" formControlName="background">
                                    <span class="file-cta">
                                      <span class="file-icon">
                                        <i class="fa fa-upload"></i>
                                      </span>
                                      <span class="file-label">
                                        Seleccionar archivo
                                      </span>
                                    </span>

                                  </label>
                                </div>
                              </div>
                              <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, item.controls.background, 'evento')"
                                *ngIf="item.get('background').value != ''">

                                <span class="icon ">
                                  <i class="icon-trash"></i>
                                </span>
                                &nbsp; Eliminar la imagen
                              </button>

                              <button type="button" class="button is-success" *ngIf="item.controls.background.value != ''" (click)="ctrl.abrirModal('verFoto' + i)">
                                <span class="icon">
                                  <i class="icon-eye2"> </i>
                                </span>
                                &nbsp; Ver Foto
                              </button>
                            </div>

                            <div class="modal" id="verFoto{{i}}">
                              <div class="modal-background"></div>
                              <div class="modal-content" [ngInit]="ctrl.subir['b' + i]=false">
                                <p class="image is-4by3">
                                  <img *ngIf="!ctrl.subir['b' + i]" [src]="ctrl.API_PATH+'/adjunto/evento/'+item.get('background').value" alt="Foto" />
                                  <img *ngIf="ctrl.subir['b' + i]" [src]="'data:image/jpg;base64,'+item.get('background').value" alt="Foto" />
                                </p>
                              </div>
                              <button type="button" class="modal-close" (click)="ctrl.cancelarModal('verFoto' + i)"></button>
                            </div>
                          </div>

                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Porcentaje de asistencia requerida:</label>
                              <div class="control has-icons-left has-icons-right">
                                <input class="input" type="number" min="0" max="100" [ngClass]="{'is-danger': item.controls.porcentaje_reconocimiento.hasError('required')}"
                                  formControlName="porcentaje_reconocimiento">
                                <span class="icon is-small is-right" *ngIf="item.controls.porcentaje_reconocimiento.hasError('required') ">
                                  <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="item.controls.porcentaje_reconocimiento.hasError('required') ">Este campo es requerido.</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <fieldset>
                          <legend>Configuración  para imprimir el nombre:</legend>
                          <br>
                          <div class="columns">
                            <div class="column is-6">
                              <div class="field">
                                <label class="label">Milimetros en el eje x:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="number" [ngClass]="{'is-danger': item.controls.mm_x.hasError('required')}"
                                    formControlName="mm_x">
                                  <span class="icon is-small is-right" *ngIf="item.controls.mm_x.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.mm_x.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-6">
                              <div class="field">
                                <label class="label">Milimetros en el eje y:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="number" min="0" max="100" [ngClass]="{'is-danger': item.controls.mm_y.hasError('required')}"
                                    formControlName="mm_y">
                                  <span class="icon is-small is-right" *ngIf="item.controls.mm_y.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.mm_y.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Tipo de letra:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <ng-select2 [disabled]="fonts ? fonts.length == 0 ? true : false : true" name="font_family" [options]="ctrl.optionSelect" [value]="item.controls.font_family.value"
                                    (valueChanged)="ctrl.seleccionarValorSelect2($event, item.controls.font_family);" [data]="fonts"></ng-select2>
                                  <span class="icon is-small is-right" *ngIf="item.controls.font_family.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.font_family.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Tamaño de letra:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="number" min="0" max="100" [ngClass]="{'is-danger': item.controls.font_size.hasError('required')}"
                                    formControlName="font_size">
                                  <span class="icon is-small is-right" *ngIf="item.controls.font_size.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.font_size.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Color de letra:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="color" [ngClass]="{'is-danger': item.controls.color.hasError('required')}"
                                    formControlName="color">
                                  <span class="icon is-small is-right" *ngIf="item.controls.color.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.color.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  </div>

                  <div class="button is-primary is-outlined is-fullwidth" style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.eventos_constancias, form_eventos_constancias)">
                      <i class="fa fa-plus"></i> &nbsp; Agregar
                    </button>
                  </div>

                  </div>


                </section>
            </form>
        </div>
    </div>
</div>


<div class="modal" id="verFoto">
    <div class="modal-background"></div>
    <div class="modal-content">
        <p class="image is-4by3">
            <img *ngIf="!ctrl.subir[0]" [src]="ctrl.API_PATH+'/adjunto/evento/'+ctrl.dato.get('imagen').value" alt="Foto" />
            <img *ngIf="ctrl.subir[0]" [src]="'data:image/jpg;base64,'+ctrl.dato.get('imagen').value" alt="Foto" />
        </p>
    </div>
    <button type="button" class="modal-close" (click)="ctrl.cancelarModal('verFoto')"></button>
</div>
